/*
 * GTC Wishlist (custom, replaces Minimog's built-in wishlist) — Oct 2026
 * - Hearts on product cards + product pages (.m-wishlist-button[data-product-handle])
 * - Saves in the browser for everyone; syncs to the customer's account when logged in
 * - Header count, "Saved" toast, Klaviyo events, share links
 * Config comes from snippets/gtc-wishlist-config.liquid (window.GTCWishlistConfig).
 */
(function () {
  if (window.GTCWishlist) return;

  var CFG = window.GTCWishlistConfig || {};
  var KEY = 'gtc-wishlist-v2';
  var LEGACY_KEY = 'm-wishlist-products';
  var DAY = 864e5;

  function now() { return Date.now(); }
  function safeGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function qsa(s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }

  /* ---------- state: {items:{handle:{v:variantId|null,a:addedAt}}, removed:{handle:removedAt}} ---------- */
  function emptyState() { return { items: {}, removed: {} }; }

  function loadState() {
    var st = emptyState();
    try {
      var raw = JSON.parse(safeGet(KEY) || 'null');
      if (raw && raw.items) st = { items: raw.items || {}, removed: raw.removed || {} };
    } catch (e) {}
    // one-time import of the old theme wishlist (array of handles)
    try {
      var legacy = JSON.parse(safeGet(LEGACY_KEY) || 'null');
      if (Array.isArray(legacy) && legacy.length && !safeGet(KEY + '-migrated')) {
        var t = now() - legacy.length;
        legacy.forEach(function (h, i) { if (h && !st.items[h]) st.items[h] = { v: null, a: t + i }; });
        safeSet(KEY + '-migrated', '1');
      }
    } catch (e) {}
    return st;
  }

  // Merge two states: a product is on the list if its latest "add" is newer than its latest "remove".
  function mergeStates(a, b) {
    var out = emptyState();
    var handles = {};
    [a, b].forEach(function (s) {
      Object.keys(s.items || {}).forEach(function (h) { handles[h] = 1; });
      Object.keys(s.removed || {}).forEach(function (h) { handles[h] = 1; });
    });
    var cutoff = now() - 120 * DAY;
    Object.keys(handles).forEach(function (h) {
      var ia = (a.items || {})[h], ib = (b.items || {})[h];
      var add = null;
      if (ia && ib) add = ia.a >= ib.a ? ia : ib; else add = ia || ib;
      var rem = Math.max((a.removed || {})[h] || 0, (b.removed || {})[h] || 0);
      if (add && add.a > rem) out.items[h] = { v: add.v || null, a: add.a };
      else if (rem && rem > cutoff) out.removed[h] = rem;
    });
    return out;
  }

  var state = loadState();

  function save() { safeSet(KEY, JSON.stringify(state)); }

  function handles() {
    return Object.keys(state.items).sort(function (x, y) { return state.items[y].a - state.items[x].a; });
  }

  function has(h) { return !!state.items[h]; }

  /* ---------- server sync (logged-in customers) + anonymous counts for the report ---------- */
  var syncTimer = null;
  function api(path, body) {
    if (!CFG.endpoint) return Promise.resolve(null);
    return fetch(CFG.endpoint.replace(/\/$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' }, // simple request, no CORS preflight
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function syncNow() {
    var c = CFG.customer;
    if (!c || !c.sig || !CFG.endpoint) return Promise.resolve();
    return api('/sync', { cid: c.id, email: c.email, name: c.first_name, ts: c.ts, sig: c.sig, state: state }).then(function (res) {
      if (res && res.state) {
        var before = handles().join(',');
        state = mergeStates(state, res.state);
        save();
        if (handles().join(',') !== before) refreshAll();
      }
    });
  }
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(syncNow, 800); }

  function ping(action, h, extra) {
    if (!CFG.endpoint) return;
    var body = { a: action, h: h };
    if (extra) for (var k in extra) body[k] = extra[k];
    api('/e', body);
  }

  /* ---------- product data (cached per page) ---------- */
  var productCache = {};
  function getProduct(h) {
    if (!productCache[h]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      productCache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[h];
  }

  function money(cents) {
    var fmt = (window.MinimogSettings || {}).money_format || '${{amount}}';
    var n = Number(cents || 0) / 100;
    function group(x, dec, th, sep) {
      var parts = x.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      return group(n, 2, ',', '.');
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }

  /* ---------- Klaviyo ---------- */
  function kTrack(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') return window.klaviyo.track(name, props);
      window._learnq = window._learnq || [];
      window._learnq.push(['track', name, props]);
    } catch (e) {}
  }

  function itemProps(p, variantId) {
    var v = null;
    if (p && p.variants) v = p.variants.filter(function (x) { return String(x.id) === String(variantId); })[0] || p.variants[0];
    var origin = location.origin;
    return {
      ProductName: p ? p.title : '',
      ProductID: p ? p.id : null,
      Handle: p ? p.handle : '',
      VariantID: v ? v.id : null,
      VariantName: v && v.title !== 'Default Title' ? v.title : '',
      SKU: v ? v.sku : '',
      Price: v ? v.price / 100 : p ? p.price / 100 : null,
      CompareAtPrice: v && v.compare_at_price ? v.compare_at_price / 100 : null,
      Available: p ? !!p.available : null,
      ImageURL: p && p.featured_image ? imgUrl(p.featured_image, 800) : '',
      URL: p ? origin + '/products/' + p.handle : '',
      Brand: p ? p.vendor : '',
      Categories: p ? (p.tags || []) : []
    };
  }

  function wishlistUrl() { return location.origin + (CFG.pageUrl || '/pages/wishlist'); }

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gtc-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3200);
  }

  /* ---------- "Saved!" pop-up: View my wishlist / Keep shopping ---------- */
  var popEl = null, popLastFocus = null;
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function closePopup() {
    if (!popEl || !popEl.classList.contains('is-open')) return;
    popEl.classList.remove('is-open');
    popEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gtc-wl-pop-open');
    if (popLastFocus && popLastFocus.focus) { try { popLastFocus.focus(); } catch (e) {} }
  }
  function savedPopup(h) {
    if (!popEl) {
      popEl = document.createElement('div');
      popEl.className = 'gtc-wl-pop';
      popEl.setAttribute('aria-hidden', 'true');
      popEl.innerHTML =
        '<div class="gtc-wl-pop__backdrop" data-wl-pop-close></div>' +
        '<div class="gtc-wl-pop__card" role="dialog" aria-modal="true" aria-labelledby="GtcWlPopTitle">' +
          '<button type="button" class="gtc-wl-pop__x" data-wl-pop-close aria-label="Close">&times;</button>' +
          '<div class="gtc-wl-pop__media"><img alt="" data-wl-pop-img hidden></div>' +
          '<div class="gtc-wl-pop__heart" aria-hidden="true">&#9829;</div>' +
          '<h2 class="gtc-wl-pop__title" id="GtcWlPopTitle">Saved to your wishlist!</h2>' +
          '<p class="gtc-wl-pop__name" data-wl-pop-name></p>' +
          '<div class="gtc-wl-pop__btns">' +
            '<a class="gtc-wl-pop__btn gtc-wl-pop__btn--main" data-wl-pop-view href="' + esc(CFG.pageUrl || '/pages/wishlist') + '">View my wishlist</a>' +
            '<button type="button" class="gtc-wl-pop__btn gtc-wl-pop__btn--ghost" data-wl-pop-close>Keep shopping</button>' +
          '</div>' +
          '<p class="gtc-wl-pop__count" data-wl-pop-count></p>' +
        '</div>';
      document.body.appendChild(popEl);
      popEl.addEventListener('click', function (e) { if (e.target.closest('[data-wl-pop-close]')) closePopup(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });
    }
    var img = popEl.querySelector('[data-wl-pop-img]');
    var name = popEl.querySelector('[data-wl-pop-name]');
    img.hidden = true; img.removeAttribute('src'); name.textContent = '';
    var n = handles().length;
    popEl.querySelector('[data-wl-pop-count]').textContent = n === 1 ? '1 item on your list' : n + ' items on your list';
    getProduct(h).then(function (p) {
      if (!p) return;
      name.textContent = p.title;
      if (p.featured_image) { img.src = imgUrl(p.featured_image, 400); img.hidden = false; }
    });
    popLastFocus = document.activeElement;
    popEl.classList.add('is-open');
    popEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gtc-wl-pop-open');
    setTimeout(function () { var v = popEl.querySelector('[data-wl-pop-view]'); if (v) v.focus(); }, 30);
  }

  /* ---------- UI state ---------- */
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }

  function setButtonState(btn, on) {
    if (btn.classList.contains('added-to-wishlist') !== on) btn.classList.toggle('added-to-wishlist', on);
    setAttr(btn, 'aria-pressed', on ? 'true' : 'false');
    setAttr(btn, 'aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    setText(btn.querySelector('.m-tooltip__content'), on ? 'Remove from wishlist' : 'Add to wishlist');
    setText(btn.querySelector('.m-wishlist-button-text'), on ? 'Saved to wishlist' : 'Add to wishlist');
  }

  function setWishlistButtonsState() {
    qsa('.m-wishlist-button[data-product-handle]').forEach(function (btn) {
      setButtonState(btn, has(btn.dataset.productHandle));
    });
  }

  function updateCount() {
    var n = handles().length;
    qsa('.m-wishlist-count').forEach(function (el) {
      setText(el, String(n));
      if (el.classList.contains('m:hidden') !== (n < 1)) el.classList.toggle('m:hidden', n < 1);
      if (el.style && el.style.display === 'none' && n > 0) el.style.display = '';
    });
    if (document.body.classList.contains('wishlist-has-item') !== (n > 0)) document.body.classList.toggle('wishlist-has-item', n > 0);
  }

  function refreshAll() {
    setWishlistButtonsState();
    updateCount();
    document.dispatchEvent(new CustomEvent('gtc:wishlist:change', { detail: { handles: handles() } }));
  }

  /* ---------- public actions ---------- */
  function currentVariantFor(btn) {
    var form = btn.closest('.m-main-product, .m-product-card, [data-product-id]');
    form = form && form.querySelector('form[action*="/cart/add"] [name="id"]');
    return form && form.value ? Number(form.value) : null;
  }

  function add(h, variantId, opts) {
    if (!h) return;
    opts = opts || {};
    state.items[h] = { v: variantId || (state.items[h] && state.items[h].v) || null, a: now() };
    delete state.removed[h];
    save(); refreshAll(); scheduleSync();
    ping('add', h);
    getProduct(h).then(function (p) {
      var props = itemProps(p, variantId);
      props.WishlistCount = handles().length;
      props.WishlistURL = wishlistUrl();
      props.Source = opts.source || 'heart';
      kTrack('Added to Wishlist', props);
    });
    if (!opts.silent) savedPopup(h);
  }

  function remove(h, opts) {
    if (!h || !state.items[h]) return;
    opts = opts || {};
    delete state.items[h];
    state.removed[h] = now();
    save(); refreshAll(); scheduleSync();
    ping('remove', h);
    kTrack('Removed from Wishlist', { Handle: h, WishlistCount: handles().length });
    if (!opts.silent) toast('Removed from your wishlist');
  }

  function toggle(h, variantId) { if (has(h)) remove(h); else add(h, variantId); }

  /* ---------- heart clicks (capture phase so card links don't navigate) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.m-wishlist-button[data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.dataset.productHandle;
    var wasOn = has(h);
    toggle(h, wasOn ? null : currentVariantFor(btn));
    if (!wasOn) {
      btn.classList.remove('gtc-wl-pop'); void btn.offsetWidth; btn.classList.add('gtc-wl-pop');
    }
  }, true);

  // Keep the saved size/color in step when a shopper changes variant on the product page after saving.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.m-main-product')) return;
    setTimeout(function () {
      var h = (window.MinimogSettings || {}).productHandle;
      if (!h || !state.items[h]) return;
      var input = document.querySelector('.m-main-product form[action*="/cart/add"] [name="id"]');
      if (input && input.value && String(state.items[h].v) !== String(input.value)) {
        state.items[h].v = Number(input.value); save(); scheduleSync();
      }
    }, 50);
  });

  // New cards loaded by infinite scroll / filters / quick view
  // Only reacts when new heart buttons appear; batched to once per frame.
  var moQueued = false;
  var mo = new MutationObserver(function (muts) {
    if (moQueued) return;
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && (n.matches('.m-wishlist-button, .m-wishlist-count') || n.querySelector('.m-wishlist-button, .m-wishlist-count'))) {
          moQueued = true;
          requestAnimationFrame(function () { moQueued = false; setWishlistButtonsState(); updateCount(); });
          return;
        }
      }
    }
  });

  // Another tab changed the list
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { state = loadState(); refreshAll(); }
  });

  /* ---------- free pink gift bag with wishlist orders ---------- */
  var GIFT_BAG = Number(CFG.giftBagVariantId || 60378940866846);
  var bagBusy = false;
  function isWishlistLine(it) { return it && it.properties && (it.properties._wishlist || it.properties._wishlist === ''); }
  function checkGiftBag(cart) {
    if (bagBusy || !cart || !cart.items) return;
    var bagLines = cart.items.filter(function (it) { return Number(it.variant_id) === GIFT_BAG; });
    if (!bagLines.length) return;
    var hasWishlistItem = cart.items.some(function (it) { return Number(it.variant_id) !== GIFT_BAG && isWishlistLine(it); });
    var bagQty = bagLines.reduce(function (n, it) { return n + it.quantity; }, 0);
    var updates = {};
    if (!hasWishlistItem) bagLines.forEach(function (it) { updates[it.key] = 0; });
    else if (bagQty > 1) bagLines.forEach(function (it, i) { updates[it.key] = i === 0 ? 1 : 0; });
    else return;
    bagBusy = true;
    var ev = new CustomEvent('cart:grouped-sections', { detail: { sections: [] } });
    document.dispatchEvent(ev);
    var sections = Array.from(new Set(ev.detail.sections));
    var body = { updates: updates };
    if (sections.length) { body.sections = sections; body.sections_url = location.pathname; }
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections && window.MinimogEvents) { try { window.MinimogEvents.emit('cart-update', { cart: res }); } catch (e) {} }
        if (/^\/cart\/?$/.test(location.pathname)) location.reload();
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { bagBusy = false; }, 500); });
  }
  function refreshGiftBag() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(checkGiftBag).catch(function () {});
  }

  function init() {
    refreshAll();
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    syncNow();
    refreshGiftBag();
    try {
      if (window.MinimogEvents && window.MinimogEvents.subscribe) {
        window.MinimogEvents.subscribe('cart-update', function () { if (!bagBusy) setTimeout(refreshGiftBag, 300); });
      }
    } catch (e) {}
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshGiftBag(); });
  }

  var api_ = {
    // used by the wishlist page section
    state: function () { return state; },
    handles: handles,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    getProduct: getProduct,
    itemProps: itemProps,
    money: money,
    imgUrl: imgUrl,
    track: kTrack,
    ping: ping,
    api: api,
    toast: toast,
    giftBagVariantId: GIFT_BAG,
    refreshGiftBag: refreshGiftBag,
    config: CFG,
    wishlistUrl: wishlistUrl,
    syncNow: syncNow,
    // kept for Minimog scripts that call these
    setWishlistButtonsState: setWishlistButtonsState,
    updateWishlistCount: updateCount
  };
  window.GTCWishlist = api_;
  window.MinimogTheme = window.MinimogTheme || {};
  window.MinimogTheme.Wishlist = api_;
  try { document.dispatchEvent(new CustomEvent('gtc:wishlist:ready')); } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
